import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import {
  flex,
  position,
  rem,
  media,
  fadeIn,
  fadeInDown,
} from '../../core';

const modifiersModal = {
  hide: () => ({
    styles: `
      display: none;
    `,
  }),
  show: () => ({
    styles: `
      display: block;
    `,
  }),
};

const modifiersDialog = {
  small: () => ({
    styles: `
      max-width: ${rem(350)};
    `,
  }),
  large: () => ({
    styles: `
      max-width: ${rem(800)};
    `,
  }),
  scroll: () => ({
    styles: `
      height: 100%;
      .modal__body {
        height: 100%;
        overflow: auto;
      }
    `,
  }),
  video: () => ({
    styles: `
      background-color: black;
      padding: 0;
      @media ${media.mobileMax} {
        padding: 0;
      }
    `,
  }),
};

const modifiersWrapper = {
  centered: () => ({
    styles: `
      justify-content: center;
      .modal__dialog {
        margin-top: 0;
      }
    `,
  }),
};

export const ModalStyled = styled.div.attrs({
  className: 'component__modal',
})`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  ${position('fixed', '0', '', '', '0')};
  z-index: 999999;
  ${applyStyleModifiers(modifiersModal)};
`;

export const ModalWrapper = styled.div.attrs({
  className: 'modal__wrapper',
})`
  width: 100%;
  height: 100%;
  ${flex('column', '', 'flex-start')}
  ${applyStyleModifiers(modifiersWrapper)};
`;

export const ModalBackdrop = styled.div.attrs({
  className: 'modal__backdrop',
})`
  background: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 100vh;
  ${position('fixed', '0', '', '', '0')}
  ${fadeIn({ duration: '.5s' })};
  z-index: 1040;
`;

export const ModalCloseButton = styled.button.attrs({
  type: 'button',
})`
  background: none;
  border: none;
  width: ${rem(40)};
  height: ${rem(40)};
  outline: none;
  ${flex('row', 'center', 'center')};
  ${position('absolute', '.375rem', '.375rem', '', '')};
  cursor: pointer;
  svg {
    fill: ${(props) => props.theme.primary.main};
    width: 1rem;
    height: 1rem;
  }
  * {
    cursor: pointer;
  }
`;

export const ModalDialog = styled.div.attrs({
  className: 'modal__dialog',
})`
  background-color: white;
  width: calc(100% - 2rem);
  max-width: 500px;
  border-radius: .3rem;
  padding: ${rem(24)};
  margin: 1.75rem auto;
  ${flex('column')};
  position: relative;
  ${fadeInDown({
    duration: '.5s',
    delay: '.15s',
  })};
  z-index: 1050;
  @media ${media.mobileMax} {
    padding: ${rem(32)};
  }

  h1, h2, h3, h4, h5 {
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ${applyStyleModifiers(modifiersDialog)};
`;
